import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Forms, Modal, SaveButton, SystemText } from '@salesperformanceint/e4shared';

import { poke } from 'actions/profile';

export const PokeModal = props => {
    const dispatch = useDispatch();

    const [comment, setComment] = React.useState('');
    const [saving, setSaving] = React.useState(false);

    const closeModal = () => {
        props.close && props.close();
    };

    const { tags, handles } = useSelector(state => state.ui);

    const footer = (
        <div>
            <SaveButton
                saving={saving}
                setSaving={setSaving}
                className="btn btn-success"
                onClick={() => dispatch(poke({ ...props.task, comments: comment }, () => closeModal()))}
            >
                {SystemText('Objective/Poke/Poke')}
            </SaveButton>
            <button className="btn" onClick={closeModal}>
                {SystemText('Objective/Poke/Cancel')}
            </button>
        </div>
    );

    return (
        <Modal show={props.show} title={SystemText('Objective/Poke/Title')} close={closeModal} footer={footer}>
            <div className="row">
                <div className="col-md-12 mb10">
                    <Forms.Textarea
                        tags={tags}
                        handles={handles}
                        onChange={setComment}
                        value={comment}
                        label={SystemText('Objective/Poke/Label')}
                        rows="2"
                        placeholder={SystemText('Objective/Poke/Placeholder', props.task.assigned_Firstname)}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default PokeModal;
